var VideoCameraMapModel = (function () {

  /**
   * Модель камеры видеонаблюдения
   * @property {int} id Идентификатор
   * @property {string} name Название камеры видеонаблюдения
   * @property {double[]} coordinate Координата расположения камеры видеонаблюдения
   */
  function VideoCameraMapModel(videoCamera) {
    if (videoCamera) {
      this.id = videoCamera.Id;
      this.name = videoCamera.Name;
      this.coordinate = [videoCamera.Latitude, videoCamera.Longitude];
    }
  }

  return VideoCameraMapModel;
}());
